export const phoneNumberRegEx = /^[0]{1}([7-9]{1}[0]{1}|[8]{1}[1]{1})\d{8}$/i
export const strongPasswordRegEx = new RegExp(
  '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})'
)
export const investmentQuantityRegEx = /^[0-9\b]+$/
